import { NoDrillabilityReason } from '@upright/common/model/output/scores/sdg-alignment/api-types';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { commonInfoBoxPadding } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import styled from 'styled-components';

interface Props {
  reason: NoDrillabilityReason;
}

function getExplanation(reason: NoDrillabilityReason) {
  switch (reason) {
    case NoDrillabilityReason.SDG8:
      return <>Detail drilldowns not shown for SDG8.</>;
    case NoDrillabilityReason.SINGLE_ALIGNED_PRODUCT:
      return <>Single product with any level of alignment</>;
    case NoDrillabilityReason.SINGLE_STRONG_ALIGNED_PRODUCT:
      return <>Single strongly aligned/misaligned product</>;
    case NoDrillabilityReason.SINGLE_MODERATELY_ALIGNED_PRODUCT:
      return <>Single moderately aligned product</>;
    case NoDrillabilityReason.COVERAGE_CLASS_EXTENDED:
      return (
        <>
          Company is part of Upright's <b>extended</b> coverage.
        </>
      );
    default:
      return <>This SDG drilldown is currently not available</>;
  }
}

export function TeamDrillabilityInfo({ reason }: Props) {
  return (
    <Root>
      Drilldown is hidden externally <Reason>Reason: {getExplanation(reason)}</Reason>
    </Root>
  );
}

const Root = styled.div`
  ${commonInfoBoxPadding}
  background-color: ${BouColor.TOOL_EXPERT_MODE_HIGHLIGHT_BLUE};
  color: white;
  font-weight: bold;
`;
const Reason = styled.div`
  font-weight: normal;
`;
